import React, { createContext, useState } from "react";
import { Link, Outlet, useLoaderData, useLocation } from "react-router-dom";
import { getProducts } from "../../lib/api";
import { IAPIResponse, IProduct } from "../../types/api";
import ProductsTable from "./ProductsTable";

export const loader = async () => {
    const products = await getProducts(false);

    return {
        products,
    };
};

export const ProductsContext = createContext<{
    products: IProduct[];
    setProducts: React.Dispatch<React.SetStateAction<IProduct[]>>;
}>({ products: [], setProducts: (): void => {} });

const ProductsIndex = (): React.JSX.Element => {
    const {
        products: { products: loadedProducts },
    } = useLoaderData() as {
        products: IAPIResponse & { products: IProduct[] };
    };

    const location = useLocation();
    const isOnProductIndexPage = /league-management\/products\/?$/.test(
        location.pathname,
    );

    const [products, setProducts] = useState<IProduct[]>(loadedProducts);

    return isOnProductIndexPage ? (
        <>
            <Link
                to={`/league-management/products/add`}
                className="btn btn-primary"
            >
                Add Product
            </Link>
            <br />
            <ProductsContext.Provider value={{ products, setProducts }}>
                <ProductsTable />
            </ProductsContext.Provider>
        </>
    ) : (
        <ProductsContext.Provider value={{ products, setProducts }}>
            <Outlet />
        </ProductsContext.Provider>
    );
};

export default ProductsIndex;
